import * as tslib_1 from "tslib";
import * as React from 'react';
import { observer, inject } from 'mobx-react';
import { SelectField } from 'material-ui';
import { MenuItem } from 'material-ui';
import TextField from 'material-ui/TextField';
import PasswordField from 'material-ui-password-field';
import FlatButton from 'material-ui/FlatButton';
import Dialog from 'material-ui/Dialog';
import BusyIndicator from '../../components/BusyIndicator';
var defaultState = Object.freeze({
    username: "",
    password: "",
    errorMessage: "",
});
var Login = /** @class */ (function (_super) {
    tslib_1.__extends(Login, _super);
    function Login(props) {
        var _this = _super.call(this, props) || this;
        _this.handleUserNameChange = function (event) {
            event.preventDefault();
            _this.setState({
                username: event.target.value
            });
        };
        _this.handlePasswordChange = function (event) {
            event.preventDefault();
            _this.setState({
                password: event.target.value
            });
        };
        _this.handleDatabaseChange = function (e, i, database) {
            _this.props.userStore.setDatabase(database);
        };
        _this.handleCancel = function () {
            _this.props.onClose();
        };
        _this.handleSubmit = function (event) {
            event.preventDefault();
            if (event.keyCode === 13) {
                _this.handleLogin();
            }
        };
        _this.handleLogin = function () { return tslib_1.__awaiter(_this, void 0, void 0, function () {
            var _a, username, password, database, success;
            return tslib_1.__generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _a = this.state, username = _a.username, password = _a.password;
                        database = this.props.userStore.database;
                        return [4 /*yield*/, this.props.userStore.login(username, password, database)];
                    case 1:
                        success = _b.sent();
                        if (success) {
                            this.props.onClose();
                        }
                        else {
                            this.setState({ errorMessage: "Hibás felhasználói név vagy jelszó" });
                        }
                        return [2 /*return*/];
                }
            });
        }); };
        _this.state = tslib_1.__assign({}, defaultState);
        return _this;
    }
    Login.prototype.componentWillReceiveProps = function (props) {
        if (props.isOpen !== this.props.isOpen) {
            this.setState(tslib_1.__assign({}, defaultState));
        }
    };
    Login.prototype.componentDidUpdate = function (prevProps) {
        var _this = this;
        if (prevProps.isOpen === this.props.isOpen || !this.props.isOpen) {
            return;
        }
        window.setTimeout(function () { return _this.focusInput(); }, 200);
    };
    Login.prototype.render = function () {
        var _a = this.props.userStore, isBusy = _a.isBusy, databases = _a.databases, database = _a.database;
        var actions = isBusy ? [] : [
            React.createElement(FlatButton, { key: "Bejelentkezés", label: "Bejelentkez\u00E9s", primary: true, onClick: this.handleLogin }),
            React.createElement(FlatButton, { key: "Mégse", style: { marginLeft: 20 }, label: "M\u00E9gse", onClick: this.handleCancel })
        ];
        return (React.createElement(Dialog, { title: "Bejelentkez\u00E9s", actions: actions, modal: false, open: this.props.isOpen, onRequestClose: this.handleCancel },
            React.createElement(BusyIndicator, { active: isBusy },
                React.createElement("form", { onKeyUp: this.handleSubmit },
                    React.createElement(TextField, { style: { display: 'block' }, className: "form-input", floatingLabelText: "Felhaszn\u00E1l\u00F3 n\u00E9v", onChange: this.handleUserNameChange }),
                    React.createElement(PasswordField, { style: { display: 'block' }, className: "form-input", floatingLabelText: "Jelsz\u00F3", onChange: this.handlePasswordChange }),
                    React.createElement(SelectField, { className: "form-input", floatingLabelText: "Adatb\u00E1zis", value: database, onChange: this.handleDatabaseChange }, databases.map(function (i) { return React.createElement(MenuItem, { key: i, value: i, primaryText: i }); })),
                    React.createElement("span", { className: "text-danger" }, this.state.errorMessage ? this.state.errorMessage : '')))));
    };
    Login.prototype.focusInput = function () {
        var input = document.querySelector('input');
        if (input) {
            input.focus();
        }
    };
    Login = tslib_1.__decorate([
        inject('userStore'),
        observer
    ], Login);
    return Login;
}(React.Component));
export { Login };



//////////////////
// WEBPACK FOOTER
// ./src/pages/login/Login.tsx
// module id = 813
// module chunks = 0